import axios from "axios"
import {getApiStatus} from "@/data/api/portal"
import {getTestData} from "@/data/repos/mockDataLoader"
import VueCompositionApi, {reactive} from "@vue/composition-api"
import Vue from "vue"

Vue.use(VueCompositionApi) // workaround for plub-in composition API, should be removed in Vue 3

// This file loads configuration from .env.xxx files if rendered on server
// and from public/config/config.json while running in browser.
// IRL when this app is served as a static assets
// file public/config/config.json will be shadowed by configMap mounted over it.

export const status: {[key: string]: boolean} = {
  loaded: false,
}

interface Config {
  [key: string]: string;
}

const config: Config = reactive({
  BASE_URL: process.env.VUE_APP_BASE_URL,
  BASE_API_URL: process.env.VUE_APP_BASE_URL,
  AUTH_URL: process.env.VUE_APP_AUTH_URL,
  AUTH_CALLBACK_URL: process.env.VUE_APP_AUTH_CALLBACK_URL,
  AUTH_API_URL: process.env.VUE_APP_AUTH_API_URL,
  AUTH_LOGOUT_URL: process.env.VUE_APP_AUTH_LOGOUT_URL,
  VERSION: "local",
})
export default config

function checkConfig() {
  for (const key in config) {
    if (!config[key]) {
      console.error("Configuration key is missing:", key)
    }
  }
}

export async function getVersion() {
  try {
    if (process.env.NODE_ENV === "test") {
      config.VERSION = "test"
    } else if (["production", "development"].includes(process.env.NODE_ENV)) {
      config.VERSION = (await getApiStatus()).version
    }
  } catch {
    config.VERSION = "UNKNOWN"
  }
  console.log("Version:", config.VERSION)
}

export async function retrieveConfig() {
  const rnd = Math.random().toString().slice(2)
  const url = `/config/config.json?v=${rnd}`
  if (process.env.NODE_ENV === "test") {
    Object.assign(config, await getTestData("config") as Config)
    return true
  }
  // noinspection ES6MissingAwait
  getVersion()
  try {
    const r = await axios.get(url)
    Object.assign(config, r.data as Config)
    checkConfig()
    status.loaded = true
    console.log("Loaded config")
    return true
  } catch (err) {
    console.error(`Failed to load configuration from ${url}`)
    console.error(err)
    console.error("Application cannot load configuration. Please contact administrator. Error code CNF001.")
    return false
  }
}
